/**
 * D5b: React hook for fetching the matter list under a given client.
 *
 * Disabled automatically when `clientId` is undefined so it can be
 * called unconditionally inside the Workspace tree (D6) regardless of
 * whether a client is selected. Query key includes `clientId` so
 * TanStack can cache and invalidate per-client independently.
 */

import { useQuery } from "@tanstack/react-query";
import { fetchMatters, type MatterListItem } from "@/lib/lexserver-client";

export function useMatters(clientId: string | undefined) {
  return useQuery<MatterListItem[], Error>({
    queryKey: ["matters", clientId],
    queryFn: () => fetchMatters(clientId!),
    enabled: Boolean(clientId),
    staleTime: 60_000,
    retry: 2,
  });
}
